/* eslint-disable react-hooks/exhaustive-deps */
import {memo, useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SelectRange, {FIELD_NAME} from '@adv-mt/mt-form-select-range'
import IconKm from '@adv-mt/mt-svg-icons/lib/Km.js'

const DEFAULT_ACTIVE_TAB = 2
const LEGACY_WRAPPER = 'legacy'

const FormKms = ({
  initialSearch,
  isBasicContent = false,
  label,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = {},
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {kms, kmsChipSeeds, kmsToChipSeeds, DEFAULT_KMS_MIN, FILTER_NAMES} = config.get('search')

  const hasLabel = Boolean(label)
  const defaultLabel = i18n.t('COMMON.KMS')
  const filterLabel = hasLabel ? label : defaultLabel

  const currentValue = {
    from: value.from ?? DEFAULT_KMS_MIN,
    to: value.to ?? DEFAULT_KMS_MIN
  }

  const options = useMemo(() =>
    kms.map(
      kmsValue => ({
        id: kmsValue,
        label: `${i18n.n(kmsValue)} ${i18n.t('COMMON.UNIT_KMS')}`
      }),
      []
    )
  )

  return (
    <SelectRange
      fromChipSeeds={kmsChipSeeds}
      toChipSeeds={kmsToChipSeeds}
      defaultActiveTabIndex={DEFAULT_ACTIVE_TAB}
      fieldName={FILTER_NAMES.KMS}
      formatterLabel={({value}) => `${i18n.n(value)} ${i18n.t('COMMON.UNIT_KMS')}`}
      isBasicContent={isBasicContent}
      initialSearch={initialSearch}
      label={filterLabel}
      onChange={onChange}
      options={{
        from: {
          name: FIELD_NAME.FROM,
          options
        },
        to: {
          name: FIELD_NAME.TO,
          options
        }
      }}
      overlayContentRef={overlayContentRef}
      pageName={pageName}
      suffix={i18n.t('COMMON.UNIT_KMS')}
      suffixIcon={<IconKm size="medium" color="currentColor" />}
      type={type}
      value={currentValue}
      withLabel={withLabel}
      wrapper={wrapper}
    />
  )
}

const FormKmsBasicContent = props => <FormKms {...props} isBasicContent />
FormKmsBasicContent.displayName = 'FormKmsBasicContent'

FormKms.displayName = 'FormKms'
FormKms.propTypes = {
  initialSearch: PropTypes.object,
  isBasicContent: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number
  }),
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export {FormKmsBasicContent}

export default memo(FormKms)
